import './style.css';

const ShipReturn = () => {
  return (
  <div className='aboutus_shipreturn_mobile'>
    <div className='aboutus_shipreturn_mobile_table'>
      <div className='aboutus_shipreturn_mobile_table_row' style={{display: "flex", justifyContent:"space-between", alignItems: "center"}}>
        <span className='aboutus_shipreturn_mobile_table_row_item shipreturn_bold'>עלות משלוח<br />מתחת ל225 שח</span>
        <span className='aboutus_shipreturn_mobile_table_row_item shipreturn_bold'>עלות משלוח<br />מ225 שח ומעלה</span>
      </div>
      <div className='aboutus_shipreturn_mobile_table_row' style={{display: "flex", justifyContent:"space-between", alignItems: "center"}}>
        <span className='aboutus_shipreturn_mobile_table_row_item'>35 שח</span>
        <span className='aboutus_shipreturn_mobile_table_row_item'>חינם</span>
      </div>
    </div>
    <div className='aboutus_shipreturn_mobile_table'>
      <div className='aboutus_shipreturn_mobile_table_row'>
        <span className='aboutus_shipreturn_mobile_table_row_item aboutus_shipreturn_mobile_full shipreturn_bold'>זמן אספקה</span>
      </div>
      <div className='aboutus_shipreturn_mobile_table_row'>
        <span className='aboutus_shipreturn_mobile_table_row_item aboutus_shipreturn_mobile_full'>3-7 ימי עסקים, אלא אם כן מצוין אחרת בעגלה</span>
      </div>
    </div>
    <div style={{direction: "rtl", marginTop: "27px"}}>
    * החל מרגע אישור ההזמנה בחברת האשראי, בימי עסקים בלבד (ימים א'- ה') ערבי חג, ימי ו' ,שבת וחגים אינם נחשבים ימי עסקים.<br/>
משלוח עד הבית באמצעות חברת שליחים.<br/>
<br/>
** לישובים מרוחקים 2-4 ימי עסקים נוספים, רשימת היישובים מתעדכנת מעת לעת. ט.ל.ח.<br/><br/>בבלנדס אנחנו מחויבים לדאוג לשביעות רצונכם המירבית, לכן במידה וקיבלתם מוצר פגום יש לפנות אלינו ונעזור בהתאם.
<br/>
ביטול עסקה בהתאם לתקנות הגנת הצרכן (ביטול עסקה), התשע"א-2010 וחוק הגנת הצרכן, התשמ"א-1981 <br/>
אפשר לבטל את ההזמנה בכל שלב עד שהיא נכנסת להדפסה, כל תמונה מודפסת וממוסגרת במיוחד בשבילכם, ולכן מרגע שההזמנה נכנסה להדפסה כבר אי אפשר לבטל אותה. פספסתם? דברו איתנו ונבדוק מה אפשר לעשות.<br/>
    </div>
  </div>
  )
}

export default ShipReturn;
